// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import Cookies from 'js-cookie'
import router from './router'
import './styles/home.css'
//引用jq
import $ from 'jquery'
// 引用bootstrap
import './assets/bootstrap-3.4.1-dist/css/bootstrap.css'
import './assets/bootstrap-3.4.1-dist/js/bootstrap.js'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//引用swiper
// import 'swiper/dist/css/swiper.css';
import  VueAwesomeSwiper from 'vue-awesome-swiper'
import  'swiper/dist/css/swiper.css'
import store from './store'
Vue.use(VueAwesomeSwiper)


Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: function(){
    return {
        num: 1,
        userName:localStorage.getItem("userName")
    }
  }, 
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js